module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!inline) { ;
__p += '\n	<span class="DescartesUIText">\n		' +
((__t = (prefix + content)) == null ? '' : __t) +
'\n		';
 if (projection) {;
__p += '\n			' +
((__t = (suffix)) == null ? '' : __t) +
'\n			';
 if (codesvalues.length === 1) {;
__p += '\n				<br>(' +
((__t = (codesvalues[0].value)) == null ? '' : __t) +
')\n			';
} else {;
__p += '\n				<select class="DescartesUISelect form-control" name="projectionSelector" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n            	';
 for (var i = 0, len = codesvalues.length; i < len; i++) { ;
__p += '\n            		<option value="' +
((__t = (codesvalues[i].code)) == null ? '' : __t) +
'" \n            		';
 if (selectedProjection === i) { ;
__p += '\n            		selected >' +
((__t = (codesvalues[i].value)) == null ? '' : __t) +
'</option>\n            		';
} else {;
__p += '\n            			>' +
((__t = (codesvalues[i].value)) == null ? '' : __t) +
'</option>\n                	';
};
__p += '\n            	';
};
__p += '\n        		</select>\n			';
};
__p += '\n		';
};
__p += '\n	</span>\n';
} else {;
__p += '\n<form class="form-horizontal">\n   <div class="form-group row">\n        <label class="DescartesUILabel col-md-4 col-lg-6 control-label">\n			' +
((__t = (prefix + content + suffix)) == null ? '' : __t) +
'\n		</label>\n		';
 if (projection) {;
__p += '\n	        <div class="col-md-8 col-lg-6">\n				';
 if (codesvalues.length === 1) {;
__p += '\n					<label  class="DescartesUILabel control-label">(' +
((__t = (codesvalues[0].value)) == null ? '' : __t) +
')</label>\n				';
} else {;
__p += '\n	            	<select class="DescartesUISelect form-control" name="projectionSelector" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n		                ';
 for (var i = 0, len = codesvalues.length; i < len; i++) { ;
__p += '\n	            		<option value="' +
((__t = (codesvalues[i].code)) == null ? '' : __t) +
'" \n	            		';
 if (selectedProjection === i) { ;
__p += '\n	            		selected >' +
((__t = (codesvalues[i].value)) == null ? '' : __t) +
'</option>\n	            		';
} else {;
__p += '\n	            			>' +
((__t = (codesvalues[i].value)) == null ? '' : __t) +
'</option>\n	                	';
};
__p += '\n	            	';
};
__p += '\n	        		</select>\n	            ';
 };
__p += '\n	        </div>\n	    ';
};
__p += '\n    </div>\n</form>\n';
};
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Info/bootstrap4/templates/LocalizedMousePosition.ejs
// module id = 439
// module chunks = 0